"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeCustomers_de_de = void 0;
function backofficeCustomers_de_de() {
    return {
        "backoffice.customers.header": "Kunden",
        "backoffice.customers.subtitle": "Verwalten Sie Ihre Kunden",
        "backoffice.customers.createbtn": "Kunde erstellen",
        "backoffice.customers.fields.email": "E-Mail",
        "backoffice.customers.fields.displayname": "Anzeigename",
        "backoffice.customers.fields.createdat": "Erstellt am",
        "backoffice.customers.remove.title": "Kunde löschen",
        "backoffice.customers.remove.confirmation": "Wollen Sie diesen Kunden wirklich löschen? Sie werden dadurch alle Referenzen (Bestellungen, Verlinkungen, Nachrichten u.a.) zu diesem Kunden verlieren. Bitte löschen Sie Kunden nur, wenn Sie wissen, was Sie tun!",
        "backoffice.customers.setpassword.title": "Passwort setzen",
        "backoffice.customers.configuration.formtitle": "Neuregistrierungen gesperrt",
        "backoffice.customers.configuration.title": "Kunden Registrierung",
        "backoffice.customers.configuration.content": "Falls Sie mit einer festen Anzahl von Kunden arbeiten oder die Kunden einen separaten Registrierungsprozess durchlaufen, können Sie hier weitere Registrierungen blockieren."
    };
}
exports.backofficeCustomers_de_de = backofficeCustomers_de_de;
